// @ts-nocheck
import { BLOCK, Events } from "../Block/index";
import { clearErrors, onErrors } from "@/utils/mixins";

import { GemmaError } from "@gemma/errors";
import Vue from "vue";
import { getRandom } from "@gemma/utils";

export function onActive({ id, state }) {
  if (id !== BLOCK) {
    if (id === this.id) {
      if (this.active !== state) {
        this.active = id === this.id ? state : !state;
      }
    } else if (this.active) {
      this.active = false;
    }
  }
}

const mapItem = function({ dataFieldName }) {
  if (this[dataFieldName] && this[dataFieldName].__mapped) {
    return this[dataFieldName];
  }

  const mapped = this.mappings.mapItem.call(this, { vm: this, [dataFieldName]: this[dataFieldName] });
  return mapped;
};

export const mixins = function(dataFieldName, defaultMappings) {
  const dataFieldName_ = dataFieldName && dataFieldName + "_";

  const props = {
    bus: {
      type: Vue,
      default: () => new Vue(),
    },
    editByDefault: {
      type: Boolean,
      default: true,
    },
    getSaveParameters: {
      type: Function,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    navigationRoute: {
      type: String,
      default: undefined,
    },
    hrefLinkPrefix: {
      type: String,
      default: undefined,
    },
    mappings: {
      type: Object,
      default: () => {
        let mappings_ = {};
        if (defaultMappings) {
          mappings_ = typeof defaultMappings === "function" ? defaultMappings() : defaultMappings || {};
        }
        return mappings_;
      },
    },
    validate: {
      type: [Function, Promise],
      default: () => true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  };

  const computed = {
    editing(): boolean {
      const editing = this.blockEditing && !this.saving && (this.active || this.editByDefault);
      return editing;
    },
  };

  const watch = {
    dirty(newValue: boolean) {
      this.bus.$emit(Events.Dirty, { id: this.id, state: newValue });
    },
    editing(newValue: boolean) {
      this.bus.$emit(Events.Edit, { id: this.id, state: newValue });
    },
  };

  if (dataFieldName_) {
    watch.valid = function(newValue) {
      this.bus.$emit(Events.Valid, { id: this.id, state: newValue });
    };
  }

  const methods = {
    clearErrors,
    onActive,
    onErrors,
    onCancel(id) {
      if (id === BLOCK) {
        if (typeof this.cancel === "function") {
          this.cancel();
        }

        this.reset();
        this.bus.$emit(Events.Reset, this.id);
        this.blockEditing = false;
        this.bus.$emit(Events.Cancelled, this.id);
      }
    },
    onEdit({ id, state, clearErrors = false }) {
      if (id === BLOCK) {
        if (clearErrors) {
          this.clearErrors();
        }
        this.blockEditing = state;
      }
    },
    async onValidate({ id, value }) {
      if (id === this.id) {
        // Convert this to a merge strategy to call parent/ child with same method names
        let valid = true;
        if (this._onValidate) {
          valid = await this._onValidate.call(this, { vm: this, [dataFieldName_]: value, errors: this.errors });
        }

        if (this.validate) {
          const valid2 = await this.validate.call(this, { vm: this, [dataFieldName_]: value, errors: this.errors });
          valid = valid && valid2;
        }

        if (this.valid !== valid) {
          this.valid = valid;
        }

        if (this.valid) {
          this.clearErrors();
        }
      }
    },
    async onChange({ id, value }) {
      if (id === this.id) {
        await this.onValidate({ id, value });
        if (this.valid) {
          const dirty = !this.mappings.areEqual.call(this, { vm: this, [dataFieldName_]: value, [dataFieldName]: this[dataFieldName] });
          this.dirty = dirty;
        } else {
          this.dirty = true;
        }
      }
    },
    onFocus() {
      const eventId = getRandom();
      Vue.nextTick(() => {
        const input = document.getElementById(this.id + "_input");
        if (input) {
          input.focus();
        }
      });
      this.bus.$emit(Events.Active, { id: this.id, state: true, eventId });
    },
    onEnter(event) {
      this.onUpdate(event);
      document.activeElement.blur();
    },
    async onSave() {
      try {
        this.saving = true;
        if (this.dirty) {
          this.clearErrors();
          if (this.getSaveParameters) {
            const parent = this.$parent ? (this.$parent.$options.name === "Block" ? this.$parent.$parent : this.$parent) : undefined;
            const { route, model, name } = this.getSaveParameters.call(parent, this);
            try {
              await this.$app.api.patch(route, model, { name });
              this.dirty = false;
            } catch (innerError) {
              const apiResponse = innerError.data.apiResponse;
              this.onErrors(apiResponse.meta.errors);
            }
          }
        }
      } catch (innerError) {
        const error = innerError instanceof GemmaError ? innerError : new GemmaError(innerError.message, { innerError });
        this.onErrors(error);
      } finally {
        this.saving = false;
        this.$emit(Events.Saved, { id: this.id, errors: this.errors, newValue: this[dataFieldName_], oldValue: this[dataFieldName] });
        this.bus.$emit(Events.Saved, { id: this.id, errors: this.errors, newValue: this[dataFieldName_], oldValue: this[dataFieldName] });
      }
    },
    onValid() {},
    getDisplayValue(fieldName) {
      const displayValue = this.mappings.displayValue ? this.mappings.displayValue.call(this, { vm: this, [fieldName]: this[fieldName] }) : this[fieldName] || "";

      return displayValue;
    },
  };

  if (dataFieldName_) {
    watch[dataFieldName] = function(newValue) {
      const equal = this.mappings.areEqual.call(this, { vm: this, [dataFieldName_]: this[dataFieldName_], [dataFieldName]: this[dataFieldName] });
      if (!equal) {
        this[dataFieldName_] = newValue;
      }
    };

    watch[dataFieldName_] = {
      immediate: true,
      handler(newValue) {
        this.displayValue = this.getDisplayValue(dataFieldName_, newValue);
      },
    };

    methods.reset = function() {
      if (this.dirty) {
        this[dataFieldName_] = mapItem.call(this, { vm: this, dataFieldName });
        this.dirty = false;
      }

      this.clearErrors();
    };
  }

  return {
    props,
    data() {
      if (!this.mappings.areEqual) {
        this.mappings.areEqual = ({ [dataFieldName]: a, [dataFieldName_]: b }) => a === b;
      }

      if (!this.mappings.mapItem) {
        this.mappings.mapItem = function() {
          return this[dataFieldName];
        };
      }

      const data = {
        displayValue: undefined,
        active: false,
        blockEditing: false,
        dirty: false,
        errors: [],
        saving: false,
        valid: true,
      };

      if (dataFieldName_) {
        data[dataFieldName_] = mapItem.call(this, { vm: this, dataFieldName });
      }

      return data;
    },
    computed,
    watch,
    created() {
      if (this.onCancel) {
        this.bus.$on(Events.Cancel, this.onCancel);
      }

      if (this.onChange) {
        this.bus.$on(Events.Change, this.onChange);
      }

      if (this.onValidate) {
        this.bus.$on(Events.Validate, this.onValidate);
      }

      if (this.onEdit) {
        this.bus.$on(Events.Edit, this.onEdit);
      }

      if (this.onSave) {
        this.bus.$on(Events.Save, this.onSave);
      }

      if (this.onSaved) {
        this.bus.$on(Events.Saved, this.onSaved);
      }

      if (this.onValid) {
        this.bus.$on(Events.Valid, this.onValid);
      }

      this.bus.$emit(Events.Created, this.id);
    },
    destroyed() {
      if (this.onCancel) {
        this.bus.$off(Events.Cancel, this.onCancel);
      }

      if (this.onChange) {
        this.bus.$off(Events.Change, this.onChange);
      }

      if (this.onValidate) {
        this.bus.$off(Events.Validate, this.onValidate);
      }

      if (this.onEdit) {
        this.bus.$off(Events.Edit, this.onEdit);
      }

      if (this.onSave) {
        this.bus.$off(Events.Save, this.onSave);
      }

      if (this.onSaved) {
        this.bus.$off(Events.Saved, this.onSaved);
      }

      if (this.onValid) {
        this.bus.$off(Events.Valid, this.onValid);
      }
    },
    methods,
  };
};
